import { render, staticRenderFns } from "./profile-tabs-menu.html?vue&type=template&id=52b1605b&scoped=true&external"
import script from "./profile-tabs-menu.js?vue&type=script&lang=js&external"
export * from "./profile-tabs-menu.js?vue&type=script&lang=js&external"
import style0 from "./profile-tabs-menu.scss?vue&type=style&index=0&id=52b1605b&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b1605b",
  null
  
)

export default component.exports